/**
 * Фильтрация истории по вводу в поле поиска.
 * Зависит от render-helpers.js (_safeEscape, getHistory — из storage.js).
 * # ⛓️ CURSOR_ANCHOR:search:history-render-filter
 */

/**
 * Быстрый фильтр истории по вводу в поле поиска
 */
function filterHistoryItems(query) {
  var historyList = document.getElementById('search-history-dropdown-list');
  if (!historyList) return;

  var queryTrimmed = query ? query.trim() : '';
  var queryLower = queryTrimmed.toLowerCase();

  // При очистке фильтра — перерендерить как дерево (возврат к иерархическому виду).
  if (!queryLower) {
    historyList.classList.remove('is-filtered');
    renderHistory(false);
    return;
  }

  // В режиме фильтра показываем плоский список и под каждым найденным рядом
  // добавляем breadcrumb-контекст цепочки (какая была последовательность прояснения).
  historyList.classList.add('is-filtered');

  var items = historyList.querySelectorAll('.search-history-item');
  var matchCount = 0;

  // Собираем карту id → displayTerm для быстрого построения breadcrumb.
  var history = getHistory();
  var byId = {};
  history.forEach(function(it) { byId[it.id] = it; });

  items.forEach(function(item) {
    // В режиме фильтра игнорируем свёрнутость и depth — всё плоско.
    item.classList.remove('branch-hidden');

    // Очищаем предыдущую breadcrumb-подпись, если была.
    var oldHint = item.querySelector('.search-history-breadcrumb');
    if (oldHint) oldHint.remove();

    var termAttr = item.getAttribute('data-display-term') || item.getAttribute('data-term') || '';
    var termElement = item.querySelector('.search-history-term');
    if (!termElement) return;

    var termLower = termAttr.toLowerCase();
    var index = termLower.indexOf(queryLower);

    if (index === -1) {
      item.style.display = 'none';
      return;
    }

    item.style.display = '';
    matchCount++;

    // Подсветка совпадения.
    var before = termAttr.substring(0, index);
    var match = termAttr.substring(index, index + queryTrimmed.length);
    var after = termAttr.substring(index + queryTrimmed.length);
    termElement.innerHTML = window._safeEscape(before) + '<b>' + window._safeEscape(match) + '</b>' + window._safeEscape(after);

    // Breadcrumb: строим путь от корня до этой записи.
    var id = item.getAttribute('data-id');
    var chain = [];
    var cur = byId[id];
    var guard = 0;
    while (cur && guard < 100) {
      chain.unshift(cur.displayTerm || cur.term || cur.query || '');
      if (!cur.parentId) break;
      cur = byId[cur.parentId];
      guard++;
    }
    if (chain.length > 1) {
      var ancestors = chain.slice(0, -1); // без самого элемента
      var immediateParent = ancestors[ancestors.length - 1];
      var hasDeeperAncestors = ancestors.length > 1;
      var hint = document.createElement('div');
      hint.className = 'search-history-breadcrumb';
      // Короткий breadcrumb: только непосредственный родитель (+ "…" если
      // дерево глубже). Полная цепочка — в title (tooltip при hover).
      hint.textContent = '\u2190 ' + (hasDeeperAncestors ? '\u2026 / ' : '') + immediateParent;
      hint.title = '\u2190 ' + ancestors.join(' / ');
      var contentBlock = item.querySelector('.search-history-term-block') || item.querySelector('.search-history-item-content');
      if (contentBlock) contentBlock.appendChild(hint);
    }
  });

  if (window._applyZebra) window._applyZebra(historyList);

  // Если нет совпадений, показываем сообщение "No matches"
  var noMatchesMsg = historyList.querySelector('.search-history-no-matches');
  if (matchCount === 0 && queryLower) {
    if (!noMatchesMsg) {
      var msgText = 'No matches found';
      if (typeof LANG_TEXTS !== 'undefined' && window.SEARCH_LANGUAGE) {
        var currentLang = window.SEARCH_LANGUAGE.getCurrentLang();
        if (LANG_TEXTS[currentLang] && LANG_TEXTS[currentLang].history_no_matches) {
          msgText = LANG_TEXTS[currentLang].history_no_matches;
        }
      }
      var msgDiv = document.createElement('div');
      msgDiv.className = 'search-history-no-matches search-history-empty';
      msgDiv.textContent = msgText;
      historyList.appendChild(msgDiv);
    }
  } else if (noMatchesMsg) {
    noMatchesMsg.remove();
  }

  // Пересчитываем высоту dropdown на мобильных устройствах
  if (window.innerWidth <= 768 && window.updateDropdownHeight) {
    window.updateDropdownHeight();
  }
}

window.filterHistoryItems = filterHistoryItems;
